{
  "title": "Prestataires",
  "description": "Gérez vos prestataires et leurs informations",
  "addProvider": "Ajouter un prestataire",
  "searchPlaceholder": "Rechercher des prestataires...",
  "deleteTitle": "Supprimer le prestataire",
  "deleteDescription": "Voulez-vous vraiment supprimer {{name}} ? Cette action est irréversible.",
  "deleteDescriptionGeneric": "Voulez-vous vraiment supprimer ce prestataire ? Cette action est irréversible.",
  "deleted": "Prestataire supprimé avec succès",
  "deleteError": "Échec de la suppression du prestataire",
  "form": {
    "createTitle": "Créer un prestataire",
    "createDescription": "Ajoutez un nouveau prestataire à votre équipe",
    "editTitle": "Modifier le prestataire",
    "editDescription": "Mettre à jour les informations du prestataire",
    "cardTitle": "Informations du prestataire",
    "cardDescription": "Saisissez les détails du nouveau prestataire",
    "editCardDescription": "Mettez à jour les détails du prestataire",
    "image": "Photo du prestataire",
    "imageHint": "Téléversez une photo de profil pour le prestataire",
    "uploading": "Téléversement...",
    "uploadFailed": "Échec du téléversement",
    "name": "Nom",
    "nameHint": "Nom complet du prestataire",
    "namePlaceholder": "Saisir le nom du prestataire",
    "email": "E-mail",
    "emailHint": "Adresse e-mail du prestataire",
    "emailPlaceholder": "Saisir l'adresse e-mail",
    "creating": "Création...",
    "updating": "Mise à jour...",
    "saveCreate": "Créer le prestataire",
    "saveUpdate": "Mettre à jour le prestataire",
    "nameRequired": "Le nom du prestataire est requis",
    "emailRequired": "L'e-mail est requis",
    "invalidEmail": "E-mail invalide",
    "noBusiness": "Sélectionnez une entreprise avant d'ajouter un prestataire",
    "noBusinessId": "ID entreprise introuvable",
    "created": "Prestataire créé avec succès",
    "createError": "Échec de la création du prestataire",
    "updated": "Prestataire mis à jour avec succès",
    "updateError": "Échec de la mise à jour du prestataire",
    "notFoundTitle": "Prestataire introuvable",
    "notFoundDescription": "Le prestataire que vous essayez de modifier est introuvable.",
    "saveChanges": "Enregistrer les modifications",
    "saving": "Enregistrement...",
    "editImageHint": "Téléversez une nouvelle photo de profil pour le prestataire"
  },
  "show": {
    "title": "Détails du prestataire",
    "documentTitle": "{{name}} | Prestataires",
    "documentTitleFallback": "Détails du prestataire",
    "emailDescription": "E-mail : {{email}}",
    "actions": "Actions",
    "editProvider": "Modifier le prestataire",
    "deleteProvider": "Supprimer le prestataire",
    "notFoundTitle": "Prestataire introuvable",
    "notFoundDescription": "Le prestataire que vous recherchez est introuvable.",
    "loadFailed": "Échec du chargement du prestataire",
    "backToProviders": "Retour aux prestataires",
    "profileImage": "Photo de profil",
    "name": "Nom",
    "email": "E-mail",
    "assignedUnits": "Unités assignées",
    "unitsCount": "{{count}} unité",
    "unitsCount_other": "{{count}} unités",
    "notAssignedUnits": "Assigné à aucune unité",
    "assignedServices": "Services assignés",
    "assignedServiceUnits": "Unités de service assignées",
    "unnamedService": "Service sans nom",
    "unnamedUnit": "Unité sans nom",
    "unitsForService": "{{count}} unité(s)",
    "serviceLabel": "Service : {{name}}",
    "unknownService": "Inconnu",
    "viewService": "Voir le service",
    "noAssignments": "Ce prestataire n'est assigné à aucune unité de service pour le moment."
  }
}
